import React from 'react';
import { Link } from 'react-router-dom'
import { Container, Row, Col, Form, Card, Button, Image } from 'react-bootstrap'
import ImageSection from './imageSection'
import { withTranslation } from 'react-i18next'

import './login.css'
import logo from '../../images/webdesign.png'

class ForgottenPassword extends React.Component{

  constructor(props){
    super(props)
    this.state = {
        formBasicEmail: '',
        formBasicEmailError: ''
    }
    this.handleOnChange = this.handleOnChange.bind(this);
    this.submitButton = this.submitButton.bind(this);
  }

  handleOnChange(e){
    this.setState({[e.target.id]: e.target.value})
  }

  submitButton(){
    if(this.state.formBasicEmail){
      var request = require('request');
      var auth = new Buffer(window._env_.REACT_APP_API_USER + ":" + window._env_.REACT_APP_API_PASSWORD).toString("base64")
      var options = {
        'method': 'GET',
        'url': `${window._env_.REACT_APP_API_URL}/${window._env_.REACT_APP_API_VERSION}/users/${this.state.formBasicEmail}/reset`,
        'headers': {
          Authorization: 'Basic ' + auth,
        }
      }
      let requestError = null
      request(options, function (error, response) {
        requestError = error
      }).on("end", () => {
        if (requestError) {
          const errors = {
            formBasicEmailError: 'Invailid'
          }
          this.setState({
            ...this.state,
            ...errors
          })
        }
        else {
          this.props.history.push('/codeVerification')
        }
      })
    }
  }

  render(){
    const {t} = this.props
    return(
      <Row className={"no-gutter"} >
        <ImageSection />
        <Col md={5} lg={5}>
          <div className={"login d-flex align-items-center py-5"}>
            <Container>
              <Row>
                <Col className={"mx-auto"} md={9} lg={8} >
                  <Image fluid src={logo} alt="Webdesign by Dennis Rupp" />
                  <h3 style={{textAlign: 'center'}}>{t('login-headline-forgottenPassword')}</h3>
                  <h6 style={{textAlign: 'center'}}>{t('login-content-forgottenPassword')}</h6>
                  <Card.Body>
                    <Form>
                      <Form.Group controlId="formBasicEmail">
                        <Form.Control 
                          type="email" 
                          placeholder={t('input-form-mail')}
                          value={this.state.formBasicEmail}
                          onChange={this.handleOnChange}
                          isInvalid={(this.state.formBasicEmailError.length > 1)}
                        />
                        <Form.Control.Feedback type="invalid">
                          {this.state.formBasicEmailError}
                        </Form.Control.Feedback>
                        <Form.Text className="text-muted">
                          {t('input-form-mail-inform')}!
                        </Form.Text>
                      </Form.Group>
                      <Button 
                        variant="primary"
                        onClick={this.submitButton} >
                        {t('button-submit')}
                      </Button>
                    </Form>
                    <Card.Text>
                      <Link to={{
                          pathname:'/codeVerification',
                        }}
                        >{t('link-password-code')}
                        </Link>
                    </Card.Text>
                  </Card.Body>
                </Col>
              </Row>
            </Container>
          </div>
        </Col>
      </Row>
    );
  }
}

export default (withTranslation()(ForgottenPassword))